import { toString } from '../util/toString.mjs';

function toLower(value) {
    return toString(value).toLowerCase();
}

export { toLower };
